import React from "react";

function WithLoading(Component) {
  return function WihLoadingComponent({ isLoading, ...props }) {
    if (isLoading === false) return <Component {...props} />;

    return (
      <div>
        <img className="m-auto d-block" alt="" width="auto" src="/img/component-loading.svg"></img>
      </div>
    );
  };
}

export default WithLoading;
